import { ShieldCheck, FileCheck2 } from "lucide-react";
import { Badge } from "@/lib/ui";

export default function TrustBadges({ user, size = "sm" }) {
  if (!user?.is_verified) return null;
  const icon = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <>
      <Badge color="teal" testid="badge-id-verified"><ShieldCheck className={icon} /> ID Verified</Badge>
      {user.background_checked && (
        <Badge color="green" testid="badge-background-checked"><FileCheck2 className={icon} /> Background Checked</Badge>
      )}
    </>
  );
}
